module.exports = __webpack_public_path__ + "img/f_1.d9fb8cdf.png";